import classnames from 'classnames';
import React, { PureComponent } from 'react';
import { Element } from 'react-scroll';
import PropTypes from 'prop-types';

import { containsHeb } from 'common/utils';
// import { artistName as artName } from './artist-name';
import * as css from './Category.scss';

class Item extends PureComponent {
	static propTypes = {
		isAllowSelect: PropTypes.bool.isRequired,
		isSelected: PropTypes.bool.isRequired,
		isPlaying: PropTypes.bool.isRequired,
		isAudioPlaying: PropTypes.bool.isRequired,
		// isFirstByLetter: PropTypes.bool.isRequired,
		onPlayClick: PropTypes.func.isRequired,
		onItemClick: PropTypes.func.isRequired,
		onShowModal: PropTypes.func.isRequired,
		title: PropTypes.string.isRequired,
		subtitle: PropTypes.string.isRequired,
		id: PropTypes.string.isRequired,
		// categoryId: PropTypes.string.isRequired,
		file: PropTypes.shape({
			selected: PropTypes.string,
			file: PropTypes.shape({
				url: PropTypes.string,
			}),
		}).isRequired,
		searchResult: PropTypes.string.isRequired,
		isAuthorSelected: PropTypes.bool.isRequired,
	};

	state = {
		isPlaying: false,
	};

	onItemClick = () => {
		if (!this.props.isSelected && !this.props.isAllowSelect) {
			this.props.onShowModal();
			return;
		}
		this.props.onItemClick(this.props.id);
	};

	onPlayClick = () => {
		this.setState(state => {
			const isPlaying = !state.isPlaying;

			// if (isPlaying) {
			// 	analytics.onPlaySnong(this.props.categoryId, this.props.songName);
			// }

			this.props.onPlayClick(this.props.id);
			return { isPlaying };
		});
	};

	highlight = (song, author) => {
		const { searchResult, isAuthorSelected } = this.props;
		let itemHighlight;

		if (searchResult === '') {
			return;
		}

		if (isAuthorSelected) {
			itemHighlight =
				searchResult
					.split('-')[0]
					.trim()
					.toUpperCase() === author.toUpperCase();
		} else {
			itemHighlight =
				searchResult
					.split('-')[1]
					.trim()
					.toUpperCase() === song.trim().toUpperCase();
		}

		// eslint-disable-next-line consistent-return
		return itemHighlight;
	};

	render() {
		const { isSelected, /* isFirstByLetter, */ subtitle, title } = this.props;
		const authorWithSong = `${subtitle.toUpperCase()} - ${title.toUpperCase()}`;

		// const itemHighlight = isFirstSearch ? authorHighlight : songHighlight;
		return (
			<Element
				name={authorWithSong}
				className={classnames(
					css.item,
					{ [css.selected]: isSelected },
					{ [css.searchResult]: this.highlight(title, subtitle) }
				)}
				data-name={authorWithSong}
			>
				<div className={css.itemContent} onClick={this.onItemClick}>
					<div className={classnames(css.itemTitle, containsHeb(`${title}`) && css.heb)} title={title}>
						{title}
					</div>
					<div className={css.itemSubtitle} title={subtitle}>
						{subtitle}
					</div>
				</div>
				<div className={css.itemPlay} onClick={this.onPlayClick}>
					<div
						className={classnames(css.itemPlayIcon, {
							[css.playing]: this.props.isPlaying && this.props.isAudioPlaying,
						})}
					>
						<div className={css.itemPlayIconBars}>
							<div className={css.itemPlayIconBar} />
							<div className={css.itemPlayIconBar} />
							<div className={css.itemPlayIconBar} />
						</div>
					</div>
				</div>
			</Element>
		);
	}
}

export default Item;
